import { render, staticRenderFns } from "./risk-assessment.vue?vue&type=template&id=6502ac9d&scoped=true"
import script from "./risk-assessment.vue?vue&type=script&lang=js"
export * from "./risk-assessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6502ac9d",
  null
  
)

export default component.exports